import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayError from 'shared/utils/displayError'
import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface testConnectionProps{
    id: number,
    setShowOverlay: Function,
}

const testConnection = async (props: testConnectionProps) => {
  props.setShowOverlay(true);
  let response: any = false

  const catchFunc = (err: AxiosError) => {
    const message: string = err.response?.data?.message ?? 'An error has occurred.'
      displayError({ errorMessage: message, setShowOverlay: props.setShowOverlay })
  }

  response = await axiosPost(apiUrls.connections + '/' + props.id + '/' + apiUrls.actionTest, {}, catchFunc)
  
  if(response.status === 200) {
      props.setShowOverlay(false);
      Store.dispatch(setMessage('Connection tested successfully.', 'success', 'instant', false))
  }

}

export default testConnection
